import { CategoryNameHr } from "../models";
import { mapCategoryToHr } from "../routes/LanguageMapper";

// Koliko puta se otprilike moze povecati broj pregleda oglasa kada je
// istaknut, po kategoriji. Vrijednosti su marketing-approved brojevi
// koje koristimo i na promo stranici i u statistici oglasa.
export const promotionMultiplier: Record<string, number> = {
  [CategoryNameHr.car]: 10,
  [CategoryNameHr.flatsForSale]: 10,
  [CategoryNameHr.housesForSale]: 10,
  [CategoryNameHr.flatsForRent]: 10,
  [CategoryNameHr.landsForSale]: 10,
  [CategoryNameHr.businessSpaceForRent]: 5,
  [CategoryNameHr.businessSpaceForSale]: 5,
  [CategoryNameHr.bikesAndScooters]: 3,
  [CategoryNameHr.commercialVehicle]: 3,
  [CategoryNameHr.partsAndExtras]: 3,
  [CategoryNameHr.vessels]: 3,
  [CategoryNameHr.marineEngines]: 3,
  [CategoryNameHr.agricultureMachines]: 5,
  [CategoryNameHr.constructionMachines]: 3,
  [CategoryNameHr.apartmentsRoomsHouses]: 2,
  [CategoryNameHr.furniture]: 2,
  [CategoryNameHr.petsForSale]: 2,
};

// Vraca multiplier za dani oglas (category/module) ili undefined ako
// za tu kategoriju nemamo definiranu vrijednost.
export const getPromotionMultiplier = (
  category?: string,
  module?: string
): number | undefined => {
  if (!category) return undefined;
  const key = mapCategoryToHr(category, module);
  return promotionMultiplier[key];
};



// WEBPACK FOOTER //
// ./src/utils/promotionMultiplier.ts